/**
 * Utility functions for Auth0 token management
 */

/**
 * Clear all Auth0 related data from localStorage
 */
export const clearAuth0Storage = () => {
  const auth0Keys = Object.keys(localStorage).filter(
    (key) =>
      key.startsWith("@@auth0") ||
      key.includes("auth0") ||
      key.includes("a0.spajs") ||
      key.startsWith("Auth0")
  );

  auth0Keys.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(`Failed to remove ${key}:`, error);
    }
  });
};

/**
 * Debug Auth0 storage contents
 */
export const debugAuth0Storage = () => {
  const auth0Keys = Object.keys(localStorage).filter(
    (key) =>
      key.startsWith("@@auth0") ||
      key.includes("auth0") ||
      key.includes("a0.spajs") ||
      key.startsWith("Auth0")
  );

  console.group("Auth0 Storage Debug");
  auth0Keys.forEach((key) => {
    try {
      // Fetch the value solely to attempt JSON.parse for debug (ignored afterward)
      void localStorage.getItem(key);
    } catch (error) {}
  });
  console.groupEnd();
};

/**
 * Check if we have a valid refresh token
 */
export const hasValidRefreshTokenInStorage = (): boolean => {
  try {
    const auth0Keys = Object.keys(localStorage).filter(
      (key) => key.startsWith("@@auth0") || key.includes("a0.spajs")
    );

    for (const key of auth0Keys) {
      const value = localStorage.getItem(key);
      if (value) {
        try {
          const parsed = JSON.parse(value);
          // Check if this storage item contains a refresh token
          if (parsed.refresh_token || parsed.body?.refresh_token) {
            return true;
          }
        } catch (parseError) {
          // Skip non-JSON values
        }
      }
    }
    return false;
  } catch (error) {
    console.warn("Error checking refresh token in storage:", error);
    return false;
  }
};
